export const IOverviewBenchmark = {
  sales_amount: 0,
  sales_number: 0,
  sales_channel_amount: 0,
  sales_channel_number: 0,
  sales_completed_amount: 0,
  sales_completed_number: 0,
  sales_cancelled_amount: 0,
  sales_cancelled_number: 0,
  sales_active_amount: 0,
  sales_active_number: 0,
}

export const IOverviewByChannel = {
  channel_count: 1,
  partner_id: 8,
  total_amount: 0,
  total_sale_numbers: 0,
}

export const IOverviewByType = {
  order_type: 0,
  order_type_name: 'Unknown',
  total_amount: '166.300',
  total_qty: '5',
  total_sale_numbers: '18',
}

export const IStoreHourlySales = {
  store_id: 115,
  total_amount: 17.8,
  total_qty: 0,
  total_sale_numbers: 5,
}

export const IHourlySales = {
  hour_range: '09:00 - 10:00',
  values: [IStoreHourlySales],
}

export const IStoreWeeklySales = {
  store_id: 115,
  total_amount: 17.8,
  total_qty: 0,
  total_sale_numbers: 5,
}

export const IWeeklySales = {
  weekday: 'Tuesday',
  values: [IStoreWeeklySales],
}

export const ISalesByItem = {
  item_id: 58,
  name: 'Burger',
  inventory_item_name: 'Burger',
  item_colour: '',
  images: ['1', '2', '3'],
  image_type: 0,
  default_price: 3.2,
  category_colour: '',
  category_name: 't22',
  total_qty: 108,
  total_amount: 394.6,
}

export const IBranchOverView = {
  list: [
    {
      store_id: 1,
      store_name: 'Doe’s Bakery',
      total_sales_amount: 0,
      total_sale_numbers: 0,
      channels: [3, 8, 1],
    },
  ],
  open_channels: 3,
  close_channels: 0,
}
